<template>
  <div class="flex flex-column flex-1">
    <u-header show-back>{{title}}</u-header>
    <form name="form" class="scrollable container flex-1" @submit.prevent="save">
      <div class="flex form-control">
        <u-input class="flex-1" :placeholder="'请输入对方称呼' + (isEdit ? '只支持单人' : '，用逗号或空格间隔')" v-model="form.name" autofocus tabindex="1">
          <span v-if="submitted&&validation.hasError('form.name')" slot="right" class="input-error">{{validation.firstError('form.name')}}</span>
        </u-input>
        <span class="gift icon-contacts select-icon" @click="showContacts=true"></span>
        <span v-if="notInContactNames.length" class="gift icon-plus select-icon" @click="autoAddContacts"></span>
      </div>
      <div class="flex form-control">
        <u-input class="form-control flex-1" placeholder="请选择礼钱分类，只支持单个分类" v-model="form.tag" tabindex="2">
          <span v-if="submitted&&validation.hasError('form.tag')" slot="right" class="input-error">{{validation.firstError('form.tag')}}</span>
        </u-input>
        <span class="gift icon-book select-icon" @click="showTags=true"></span>
        <span v-if="notInTags" class="gift icon-plus select-icon" @click="autoAddTag"></span>
      </div>
      <u-input type="number" class="form-control" placeholder="请输入礼钱数额" v-model.number="form.amount" tabindex="3">
        <span v-if="submitted&&validation.hasError('form.amount')" slot="right" class="input-error">{{validation.firstError('form.amount')}}</span>
      </u-input>
      <u-input type="date" class="form-control" placeholder="请选择日期" v-model="form.date" tabindex="4">
        <span v-if="submitted&&validation.hasError('form.date')" slot="right" class="input-error">{{validation.firstError('form.date')}}</span>
      </u-input>
      <u-button native-type="submit" style="margin-top: 40px">保存</u-button>
    </form>
    <u-popup v-model="showContacts" effect="right" full>
      <contacts-manage :selection="-1" @back="showContacts=false" @select="onContactsSelect"></contacts-manage>
    </u-popup>
    <u-popup v-model="showTags" effect="right" full>
      <tags-manage :selection="1" @back="showTags=false" @select="onTagsSelect"></tags-manage>
    </u-popup>
  </div>
</template>
<script>
import { Validator } from 'simple-vue-validator'
import { mapGetters, mapActions } from 'vuex'
import { debounce } from 'lodash'
import { format, first } from '@/utils'
export default {
  data () {
    const type = this.$route.query.type
    const histories = this.$store.getters[type + 'Histories']
    const { item, index } = this.$route.params.id ? first(histories, history => history.id === this.$route.params.id) : { item: null }
    return {
      type,
      index,
      form: {
        name: item ? item.name : '',
        tag: item ? item.tag : '',
        amount: item ? +item.amount : 100,
        date: item ? item.date : format(new Date(), 'yyyy-MM-dd')
      },
      submitted: false,
      notInTags: false,
      notInContactNames: [],
      names: [],
      showContacts: false,
      showTags: false
    }
  },
  computed: {
    ...mapGetters(['contacts', 'tags']),
    isEdit () {
      return !!this.$route.params.id
    },
    contactNames () {
      return this.contacts.map(contact => contact.name)
    },
    title () {
      return (this.isEdit ? '修改' : '添加') + (this.type === 'sent' ? '支出' : '收入')
    }
  },
  components: {
    ContactsManage: () => import('./Contacts.vue'),
    TagsManage: () => import('./Tags.vue')
  },
  validators: {
    'form.name': {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('名称必填')
      }
    },
    'form.tag': {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('分类必选')
      }
    },
    'form.amount': {
      debounce: 300,
      validator (v) {
        return Validator.value(v).float().required('金额必填').greaterThan(0, '金额不能小于0哦')
      }
    },
    'form.date': {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('必选')
      }
    }
  },
  watch: {
    'form.name': debounce(function () {
      const v = this.form.name.trim()
      if (v) {
        this.names = v.split(/,|，| /).filter(name => name)
        this.notInContactNames = this.names.filter(name => this.contactNames.indexOf(name) < 0)
      } else {
        this.names = []
        this.notInContactNames = []
      }
    }, 500),
    'form.tag': debounce(function () {
      const v = this.form.tag.trim()
      this.notInTags = !!v && !this.tags.some(tag => v === tag.name)
    }, 500)
  },
  methods: {
    ...mapActions(['addHistory', 'updateHistory', 'addContact', 'addTag']),
    onContactsSelect (selections) {
      this.form.name = selections.map(contact => contact.name).toString()
      this.showContacts = false
    },
    onTagsSelect (selections) {
      this.form.tag = selections[0].name
      this.showTags = false
    },
    autoAddContacts () {
      Promise.all(this.notInContactNames.map(name => {
        return this.addContact(name.trim())
      })).then(() => {
        this.$toast('已自动添加所有联系人')
        this.notInContactNames = []
      }).catch(() => {
        this.$toast('联系人添加失败，请继续使用')
      })
    },
    autoAddTag () {
      this.addTag(this.form.tag.trim()).then(() => {
        this.$toast('已自动添加该分类')
        this.notInTags = false
      }).catch(() => {
        this.$toast('分类添加失败，请继续使用')
      })
    },
    save () {
      this.submitted = true
      this.$validate().then(isSuccess => {
        if (isSuccess) {
          // 分类只能有1个
          if (this.form.tag.indexOf(',') > -1) {
            return this.$toast('分类不支持添加多个')
          }
          // 编辑时姓名只能有一个
          if (this.isEdit && this.form.name.indexOf(',') > -1) {
            return this.$toast('编辑时姓名只能为1个')
          }
          let promise
          if (this.isEdit) {
            promise = this.updateHistory([this.type, this.index, this.form]).then(() => {
              this.$toast('记录已修改')
            })
          } else {
            promise = Promise.all(this.names.map(name => {
              return this.addHistory([this.type, {
                name,
                tag: this.form.tag,
                amount: this.form.amount,
                date: this.form.date
              }])
            })).then(() => {
              this.$toast('记录已添加')
            })
          }
          promise.then(() => {
            this.$router.go(-1)
          }).catch(e => {
            this.$toast(e.toString())
          })
        }
      })
    }
  },
  created () {
    if (!this.$route.query.type) {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "../components/var.styl"
.select-icon
  margin-left 16px
  height 36px
  line-height @height
  width @height
  text-align center
  color #fff
  font-size 18px
  background-color $color-primary
  border-radius 4px
</style>



// WEBPACK FOOTER //
// EditHistory.vue?f1b0b7de